import { useQuery } from '@tanstack/react-query';

import { fetchProcessoByNumero, type ProcessoInterno } from '@/api/processos';

/**
 * Resolve o processo interno pelo número CNJ. **Leitura pura:** erro 404
 * quando o processo não está no acervo — visualizar um processo não pode
 * inscrevê-lo na carteira de ninguém.
 *
 * Quem precisa garantir o registro (só o peticionamento) usa
 * `useEnsureProcesso`.
 */
export function useProcessoByNumero(numero: string | undefined) {
  return useQuery<ProcessoInterno>({
    // `todos`: a resposta inclui o processo de um colega — chave própria, para não reusar a
    // de clientes antigos que ainda leem só o acervo.
    queryKey: ['processos', 'by-numero', numero, 'todos'],
    queryFn: () => fetchProcessoByNumero(numero!),
    enabled: !!numero,
    retry: false,
  });
}
